import React from "react";
import SimpleBar from "simplebar-react";
import { Purchase } from "types";
import { PurchaseProductImage } from "@/components/PurchasesMenu/PurchaseProductImage";
import { PurchaseTileBreakdown } from "@/components/PurchasesMenu/PurchaseTileBreakdown";
import { getMerchandisePurchaseItems } from "@/models/MerchandisePurchaseItem";
import { usePurchaseDrawerStore } from "@/stores/purchaseDrawerStore";

interface MerchandiseItemSidebarProps {
    purchase: Purchase;
    selectedItemId?: string;
}

const handleHeaderClick = () => {
    usePurchaseDrawerStore.getState().actions.setPurchaseItemId(null);
};

export const MerchandiseItemSidebar = ({ purchase, selectedItemId }: MerchandiseItemSidebarProps) => {
    const merchandiseItems = getMerchandisePurchaseItems(purchase);

    if (merchandiseItems.length <= 1) {
        return null;
    }

    const selectedItem = purchase.items.find((item) => item.id === selectedItemId);

    return (
        <div className="flex h-full w-80 flex-shrink-0 flex-col bg-white">
            <SimpleBar className="flex-1">
                <>
                    <div className="flex cursor-pointer bg-gray-lighter p-4 pr-2" onClick={handleHeaderClick}>
                        <PurchaseProductImage purchase={purchase} />
                        <div className="flex w-full flex-col space-y-1">
                            <div className="flex items-center justify-between text-sm lg:text-base">
                                <span className="no-translate w-40 truncate font-bold">{purchase.customerName}</span>
                            </div>
                        </div>
                    </div>

                    <PurchaseTileBreakdown isDrawerContext purchase={purchase} selectedItem={selectedItem} />
                </>
            </SimpleBar>
        </div>
    );
};
